import { getFirestore } from 'firebase/firestore';
import { app } from './firebase.js';
const db = app ? getFirestore(app) : false;
export default db;
